import buildQuery from 'odata-query';
import store from 'store';
import axios from 'axios';

import { FilterDataSelectedCustomer } from 'utils/SelectedCustomerId';
import { IRequestConfig, MethodsTypes } from 'models/Axios';
import { IOrdersData, IOrders } from 'models/Order';

import { TableFilterStateOrder, TableFilterStateOrderItems } from 'components/Table/Orders/interface';
import toast from 'components/Toast/dispatch';

import Services from './index.service';
export default class OrderServices extends Services<IOrdersData, IOrders> {

  get = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    filter?: TableFilterStateOrder,
  ) => {

    const skip = currentPage || 0;
    const top = pageSize || 20;
    const sort = orderby || undefined;

    const sortField = sort ? sort.replace('/', '.') : undefined;

    const order = sortField?.split(' ').reverse();

    const params = {
      search: filter?.textFilter || undefined,
      startPeriod: filter?.startPeriod || undefined,
      lastPeriod: filter?.lastPeriod || undefined,
      customerIds: FilterDataSelectedCustomer() || undefined,
      filterDate: filter?.filterDate || undefined,
      status: filter?.status || undefined,
      enterpriseCodes: filter?.enterpriseCode || undefined,
      subsidiaryIds: filter?.subsidiary || undefined,
      orderType: filter?.orderType || 0,
      documentNumber: filter?.documentNumber || undefined,
      sortBy: order?.[1] || "enterpriseName",
      sortDirection: order?.[0] || "desc",
      skip: (skip * top),
      top: top,
    };

    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== '')
    );

    const config: IRequestConfig<IOrders> = {
      url: '/order/filters',
      params: filteredParams,
    };

    return this.httpRequest(config);

  };

  getId = (id: string | undefined) => {
    if (id) {
      const config: IRequestConfig<IOrders> = {
        url: `/order/${id}`
      };

      return this.httpRequest(config);
    }

    return false;
  };

  getItems = (
    currentPage?: number,
    pageSize?: number,
    orderby?: string,
    orderId?: string,
    filter?: TableFilterStateOrderItems,
  ) => {
    const skip = currentPage || 0;
    const top = pageSize || 20;
    const sort = orderby || undefined;

    const order = sort?.split(' ').reverse();

    const config: IRequestConfig<IOrders> = {
      url: `/order/filters/items/${orderId}`,
      params: {
        orderItemStatusType: filter?.orderItemStatusType,
        sortBy: order?.[1] || "number",
        sortDirection: order?.[0] || "asc",
        skip: (skip * top),
        top: top,
      },
    };

    return this.httpRequest(config);
  };

  getHistoryTimeline = async (orderId: string) => {
    const config: IRequestConfig<{ orderId: string; }> = {
      url: `${this.base_url}/order/timeline-history?orderId=${orderId}`,
      method: MethodsTypes.get,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${this.access_token()}`,
      },

    };

    axios.interceptors.response.use(
      (response) => {
        return response;
      },
      (error) => {
        return error.response;
      }
    );

    const request = await axios(config)
      .then((result) => result);

    if (request.status === 200) return request.data.data;
  };

  public async downloadExportData(
    filter?: any,
    orderby?: string | undefined,
  ) {

    const sort = orderby || undefined;
    const order = sort?.split(' ').reverse();

    const config: IRequestConfig<IOrders> = {
      url: '/order/export-order',
      params: {
        search: filter?.textFilter,
        startPeriod: filter?.startPeriod,
        lastPeriod: filter?.lastPeriod,
        customerIds: FilterDataSelectedCustomer(),
        filterDate: filter?.filterDate,
        status: filter?.status,
        enterpriseCodes: filter?.enterpriseCode,
        subsidiaryIds: filter?.subsidiary,
        orderType: filter?.orderType,
        ticketReason: filter?.ticketReason,

        sortBy: "",
        sortDirection: order?.[0] || "desc",
        skip: 0,
        top: '99999999',
      },
      timeout: 600000
    };

    return await this.httpRequest(config)
      .then(result => {
        toast.info("Seus dados estão sendo processados", 'Aguarde enquanto coletamos todos os dados solicitados. Você será notificado por e-mail assim que o relatório estiver finalizado.');
      })
      .catch(() => toast.error('O relatório demorou mais que o esperado, estaremos enviando por email, por favor aguarde.'));
  }

  public static CreateDownloadLink = (path: string | undefined) => {
    if (path) {
      const link = document.createElement('a');
      link.href = path;
      link.download = 'download';
      link.click();
    }
  };
}
